<template lang='pug'>
  v-autocomplete(
    :label='label'
    @input='update'
    :value='value'
    :loading='loading'
    :items='available'
    item-text='name'
    :search-input.sync='search'
    return-object
    chips
    small-chips
    open-on-clear
    clearable)
    template(v-slot:item='{item}')
      v-list-item-content
        v-list-item-title(v-text='item.name')
        v-list-item-subtitle(v-text='item.description')
    template(v-slot:no-data)
      v-list-item
        v-list-item-content
          v-list-item-title
            | No suites matching &quot;
            strong {{ search }}
            | &quot;

</template>

<script>
import _ from 'lodash';
import TestSuite from '../api/testSuite';

export default {
  name: 'SuiteFilter',
  async mounted() {
    await this.load();
  },
  props: {
    label: {
      default() {
        return 'Filter by Suite';
      }
    },
    value: {
      default() {
        return null;
      }
    }
  },
  methods: {
    async load() {
      this.loading = true;
      const projection = {
        name: true,
        description: true,
        guid: true
      };
      const limit = 10;
      const {list} = await TestSuite.list({limit, projection, search: this.search});
      this.available = [...this.available, ...list];
      this.loading = false;
    },
    update(value) {
      this.$emit('input', value);
    }
  },
  watch: {
    // eslint-disable-next-line
    search: _.debounce(function () {
      this.load();
    }, 250)
  },
  data() {
    return {
      available: [],
      search: null,
      loading: false
    };
  }
};
</script>

<style scoped>

</style>
